import React from 'react';

import styles from './savedSearchFormStyles';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';
import Link from 'buyside/components/presentation/Link/link';

import { manageSavedSearchesUrl } from 'buyside/util/urlHelper';

class SavedSearchForm extends React.Component {
  constructor() {
    super();
    this.defaultState = { name: '', active: true, error: null, loading: false };
    this.state = this.defaultState;

    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleTextChange(e) {
    this.setState({ name: e.target.value });
  }

  handleCheck() {
    this.setState({ active: !this.state.active });
  }

  handleSubmit() {
    if (!this.props.search) return;
    const { handleCreateSearchAlert, savedSearchNames } = this.props;
    const { name, active } = this.state;
    if (!name) {
      this.setState({ error: "Name can't be blank" });
    } else if (
      savedSearchNames &&
      Array.isArray(savedSearchNames) &&
      savedSearchNames.indexOf(name.toLowerCase()) > -1
    ) {
      this.setState({ error: 'Name already exists' });
    } else {
      const query = this.props.search.slice(1);
      const data = { name, query, active };
      this.setState({ loading: true });
      const success = () => {
        this.setState({ loading: false });
        this.props.closeModal();
      };
      const error = e => this.setState({ error: e.graphQLErrors[0].message, loading: false });

      handleCreateSearchAlert({ variables: data }).then(success, error);
    }
  }

  render() {
    const { name, active, error, loading } = this.state;
    const { closeModal } = this.props;
    return (
      <div className={styles.container}>
        <section className={styles.inputArea}>
          <label>
            Name This Saved Search
            <input
              type="text"
              value={name}
              onChange={this.handleTextChange}
              className={styles.nameArea}
            />
          </label>
          <p className={styles.descriptionText}>
            Your saved search will be most useful if you name it something short and
            self-descriptive, e.g. <em>"Aerospace & Defense in Asia".</em> Names can be edited
            later.
          </p>
          <label className={styles.activeArea}>
            <input type="checkbox" checked={active} onChange={this.handleCheck} />
            Email me new results matching this criteria.
          </label>
          <Link to={manageSavedSearchesUrl()}>Manage Saved Searches</Link>
        </section>
        {error && <div className={styles.errorArea}>{error}</div>}
        <Button
          text="Save Search"
          type={BUTTON_TYPES.PRIMARY}
          onClick={this.handleSubmit}
          size={BUTTON_SIZES.MEDIUM}
          isLoading={loading}
        />
        <Button text="Cancel" onClick={closeModal} size={BUTTON_SIZES.MEDIUM} isLoading={loading} />
      </div>
    );
  }
}

export default SavedSearchForm;
